export default "__VITE_ASSET__C74K3ZwW__"